import React, { useEffect, useState } from 'react';
import { Tab } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import '../users/Users.scss';
import CustomTable from '../../components/customTable/CustomTable';
import { getUserList, getUserSearch, updateUserActiveStatus } from "./slice/slice";
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/loader/Loader';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Users() {
    const [activeTab, setActiveTab] = useState("all");
    const [searchText, setSearchText] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading, getUser, searchUser } = useSelector(state => state.UserSlice);
    const tableHeaders = ['Id', 'Full Name', 'Email', 'Gender', 'Subscription', 'User Status'];

    const tabToQueryMap = {
        all: '?type=all',
        active: '?type=active',
        inactive: '?type=inactive',
    };

    useEffect(() => {
        dispatch(getUserList(tabToQueryMap[activeTab]));
    }, [dispatch, activeTab]);

    useEffect(() => {
        let queryParam = tabToQueryMap[activeTab];
        if (searchText) {
            queryParam += `&input_search=${searchText}`;
        }
        dispatch(getUserSearch(queryParam));
    }, [dispatch, activeTab, searchText]);

    const handleSearchChange = (newSearchText) => {
        setSearchText(newSearchText);
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const processUserData = (users) => {
        return users.map(user => ({
            id: user.user_id,
            fullName: `${user.first_name} ${user.last_name}`,
            email: user.email,
            gender: user.gender,
            premiumsubscription: user.plan,
            userStatus: user.is_active ? 'Active' : 'Inactive',
        }));
    };

    const processedUserData = processUserData(getUser ?? []);

    const processSeachUserData = (users) => {
        return users.map(user => ({
            id: user.user_id,
            fullName: `${user.fname} ${user.lname}`,
            email: user.email,
            gender: user.gender,
            premiumsubscription: user.plan,
            userStatus: user.is_active ? 'Active' : 'Inactive',
        }));
    };

    const processedSearchUserData = processSeachUserData(searchUser ?? []);

    const handleToggleClick = (rowData) => {
        const userParams = `?type=all`;
        const queryParam = `?user_id=${rowData.id}`;
        dispatch(updateUserActiveStatus(queryParam))
            .then((res) => {
                toast.success(res?.payload?.message || 'User status updated successfully');
                dispatch(getUserList(userParams))
            })
            .catch(error => {
                toast.error('Failed to update user status' || error);
            });
    };

    const handleEyeClick = (rowData) => {
        console.log('Row data to pass:', rowData);
        navigate('/activepayments', { state: { user: rowData } });
    };

    const renderCustomTable = () => (
        <CustomTable
            title='Buyers List'
            data={searchText ? processedSearchUserData : processedUserData}
            headers={tableHeaders}
            showSearchBar='true'
            actionsHeaderText='Action'
            showSearchBarButtons
            showActions
            showView
            showtablecss={true}
            showEyeIcon
            onEyeClick={handleEyeClick}
            showPagination
            onSearchChange={handleSearchChange}
            showSlider
            onToggleClick={(rowData) => handleToggleClick(rowData)}
        />
    );

    return (
        <>
            {isLoading && <Loader />}
            <div className='users main-Page-css'>
                <div className='main-page-title'>User list</div>
                <div className='mt-4'>
                    <Tab.Container defaultActiveKey="all" activeKey={activeTab} onSelect={handleTabChange}>
                        <div className={'d-flex justify-content-between align-items-center'}>
                            <div className='tab-box'>
                                <Nav>
                                    <Nav.Item>
                                        <Nav.Link eventKey="all" style={{ marginRight: 10 }}>All</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="active" style={{ marginRight: 10 }}>Active</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="inactive">Inactive</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </div>
                        <div style={{ marginTop: 32 }}>
                            <Tab.Content>
                                <Tab.Pane eventKey="all">
                                    {renderCustomTable()}
                                </Tab.Pane>
                                <Tab.Pane eventKey="active">
                                    {renderCustomTable()}
                                </Tab.Pane>
                                <Tab.Pane eventKey="inactive">
                                    {renderCustomTable()}
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </div>
            </div>
        </>
    );
}

export default Users;
